__turbopack_context__.v({
  "carouselShowcaseSlide": "CarouselShowcaseSlide-module-scss-module__eB9YIG__carouselShowcaseSlide",
  "column": "CarouselShowcaseSlide-module-scss-module__eB9YIG__column",
  "eyebrow": "CarouselShowcaseSlide-module-scss-module__eB9YIG__eyebrow",
  "eyebrowWrap": "CarouselShowcaseSlide-module-scss-module__eB9YIG__eyebrowWrap",
  "fade-in": "CarouselShowcaseSlide-module-scss-module__eB9YIG__fade-in",
  "headline": "CarouselShowcaseSlide-module-scss-module__eB9YIG__headline",
  "headlineLine": "CarouselShowcaseSlide-module-scss-module__eB9YIG__headlineLine",
  "headlineLineWrap": "CarouselShowcaseSlide-module-scss-module__eB9YIG__headlineLineWrap",
  "image": "CarouselShowcaseSlide-module-scss-module__eB9YIG__image",
  "imageWrapper": "CarouselShowcaseSlide-module-scss-module__eB9YIG__imageWrapper",
  "imageWrapperInner": "CarouselShowcaseSlide-module-scss-module__eB9YIG__imageWrapperInner",
  "isActive": "CarouselShowcaseSlide-module-scss-module__eB9YIG__isActive",
  "isPrev": "CarouselShowcaseSlide-module-scss-module__eB9YIG__isPrev",
  "textLockup": "CarouselShowcaseSlide-module-scss-module__eB9YIG__textLockup",
});
